
<template>
  <el-breadcrumb separator="/" class="pc-breadcrumb">
    <el-breadcrumb-item v-for="item in data" :key="item.name">
      <router-link :to="item.link">
        {{ item.name }}
      </router-link>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["data"],
  created() {},
  methods: {},
};
</script>
<style  lang="scss">
.pc-breadcrumb {
  margin-top: 45px;
  .el-breadcrumb__item {
    font-size: 16px;
    .el-breadcrumb__inner {
      a {
        height: 27px;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #434343;
      }
    }
    .el-breadcrumb__separator {
      margin: 0 5px;
    }
    .el-breadcrumb__inner a:hover {
      cursor: pointer;
      a {
        color: $timeBtn;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/template/BreadCrumb.vue